import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Formik, ErrorMessage } from 'formik'
import _ from 'lodash'

import { Button, Icon, TextInputWithIcon } from 'components/shard'
import { Size, Color } from 'const'

import Alert from 'components/Alert'

import { usePasswordHook } from 'hooks'

function PasswordReset() {
  const [values, setValues] = useState({})
  const [show, setShow] = useState(false)
  const {
    token,
    errors,
    setErrors,
    resetSchema,
    execResetPassword,
    isResettingPassword,
    isSuccess,
    history,
  } = usePasswordHook()

  useEffect(() => {
    if (_.isEmpty(values)) {
      return
    }

    execResetPassword(token, values.password)
  }, [values, execResetPassword, token])

  useEffect(() => {
    if (isSuccess) {
      history.push('/password/reset/complate')
    }
  }, [history, isSuccess])

  const handleIconPasswordClick = () => {
    setShow(!show)
  }

  return (
    <Wrapper>
      <TitleBlock>パスワード再設定</TitleBlock>
      <Message>新たなパスワードを入力してください</Message>
      {errors.length > 0 && (
        <Alert type="error" message="エラー" description={errors.join('\n')} onClose={() => setErrors([])} />
      )}
      <FormWrapper>
        <Formik
          initialValues={{ password: '' }}
          onSubmit={(values) => {
            setValues(values)
          }}
          validationSchema={resetSchema}
        >
          {({ values, handleChange, handleBlur, handleSubmit, dirty, isValid }) => (
            <form onSubmit={handleSubmit}>
              <TextInputWithIcon
                type={show ? 'text' : 'password'}
                name="password"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.password}
                ariaLabel="password"
                placeholder="パスワード"
                errorMessage={<ErrorMessage name="password" />}
                subfix={<Icon icon={show ? 'eye' : 'eye-blocked'} size="16" />}
                subfixClick={handleIconPasswordClick}
                width="100%"
              />
              <ButtonWrapper>
                <Button type={'submit'} primary disabled={!isValid || !dirty || isResettingPassword}>
                  パスワードを設定する
                </Button>
              </ButtonWrapper>
            </form>
          )}
        </Formik>
      </FormWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  padding: 30px 20px;
`

const TitleBlock = styled.div`
  color: ${Color.FONT.NORMAL};
  font-size: ${Size.FONT.HEADLINE.SMALL};
  padding: 40px 0px 20px 0px;
`

const Message = styled.div`
  padding: 10px 0;
  color: ${Color.FONT.ANNOTATION};
  border-bottom: 1px solid #ccc;
`

const FormWrapper = styled.div`
  grid-column: 2;
  grid-row: 3;
  padding-top: 20px;
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 20px;
`

PasswordReset.propTypes = {
  values: PropTypes.object,
  touched: PropTypes.object,
  errors: PropTypes.object,
  dirty: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  handleSubmit: PropTypes.func,
}

export default PasswordReset
